// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2H9pY","option":"styles_option__1if3K","active":"styles_active__1YStv"};